import * as React from 'react';
// mui
import {
  Button,
  Divider,
  DialogContent,
  TextField,
  DialogActions,
  Grid,
  Dialog,
  DialogTitle,
  useTheme,
  useMediaQuery,
} from '@mui/material';
// redux
import { useSelector } from 'react-redux';
import { selectTaskById } from '../../../store/selectors/taskSelectors';
// types
import Task from '../../../interfaces/Task.interface';
import MiniTask from '../../../interfaces/MiniTask.interface';
// axios
import api from '../../../axios';
// components
import ItemBreadcrumbs from '../../common/ItemBreadcrumbs';

interface TaskDialogProps {
  onSave: (miniTask: MiniTask) => void;
  onCancel: () => void;
  parentTaskId: number;
}

export default function AddMiniTaskDialog(props: TaskDialogProps) {
  const { onSave, onCancel, parentTaskId } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // redux
  const localParentTask: Task = useSelector(selectTaskById(parentTaskId)) as Task;

  const [ newMiniTaskTitle, setNewMiniTaskTitle ] = React.useState<string>('');
  const [ open, setOpen ] = React.useState(true); // by default open the modal as it is conditionally rendered in parent
  const [ loading, setLoading ] = React.useState(false);

  const handleDialogClose = () => {
    onCancel();
    setOpen(false);
    setNewMiniTaskTitle('');
  }

  const handleDialogSave = () => {
    setLoading(true);
  
    api.post(`/tasks/mini/create`, {
      parentTaskId: parentTaskId,
      title: newMiniTaskTitle,
    })
      .then((res) => {
        console.log(res);

        setOpen(false);
        setNewMiniTaskTitle('');
        setLoading(false);

        onSave(res.data);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  return (
    <Dialog
      open={open}
      fullScreen={isMobile}
      onClose={handleDialogClose}
      fullWidth
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
          },
        },
      }}
    >
      <DialogTitle sx={{ pb: 1, pt: 1 }}>
        <ItemBreadcrumbs
          currentItem={localParentTask}
          itemType="task"
          includeCurrentItem={true}
        />
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ px: isMobile ? 2 : '', py: 0.5 }}>
        <Grid sx={{ mb: 2 }} container spacing={1}>
          <Grid size={12} >
            <TextField
              value={newMiniTaskTitle}
              onChange={(e) => { setNewMiniTaskTitle(e.target.value); }}
              onKeyDown={(e) => { if (e.code === 'Enter') handleDialogSave() }}
              sx={{ my: 0 }}
              autoFocus
              required
              margin="dense"
              id="name"
              label="Title"
              fullWidth
              variant="standard"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleDialogClose}>Cancel</Button>
        <Button
          variant="contained"
          loading={loading}
          onClick={(e) => { e.preventDefault(); handleDialogSave() }}
          disabled={!newMiniTaskTitle}
        >Add</Button>
      </DialogActions>
    </Dialog>
  )
}